<template>
  <div class="signature">
    <h1 class="signature__title">Kas</h1>
    <img class="signature__picture" :src="logoImage" alt="Kas">
  </div>
</template>

<script>
import Logo from './_images/signature.svg'
export default {
  name: 'TheSignature',
  data () {
    return {
      logoImage: Logo
    }
  }
}
</script>

<style lang="scss">
.signature{
  padding: 2rem;
  opacity: 0.8;
  transition: all 1000ms ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;

  // Title

  &__title{
    @include hide-visually;
    margin: 0;
    flex: 0 1 auto;
  }

  // Picture

  &__picture{
    width: 80%;
    flex: 0 1 auto;
  }
}
</style>
